module.exports = __webpack_public_path__ + "static/media/aramith.7a0e3922.png";